import React from 'react'
import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import "./TitleDivSeo.css"
import DialogDescription from './DialogDescription';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import { useContext } from 'react';
import { StatusContext } from '../ContextApiStatus';
export default function ContentSeo(props) {

  const { statustitle, numOfStatustitle, updateStatustitle, updateNumOfStatustitle } = useContext(StatusContext);
    const [open, setOpen] = useState('');

    const [status,setStatus] = ("true");

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = (e) => {
      setOpen(false);
    }
    const theme = useTheme();

    const { title } = props;

    // Check if title is defined before accessing its length
    const numberOfCharacters = title ? title.length : 0;
  
    const { description } = props;

    // Check if title is defined before accessing its length
    const numberOfdescription = description ? description.length : 0;


  return (
    <div id={`section-${props.index}`}>
        <div className='TitleDivSeo' style={{marginTop:"110px"}} >
        <h3 style={{color:"#999999",textAlign:"right"}}>تحسين محركات البحث</h3>
        <br />
       <hr />
       <br />
       <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>عنوان الموقع</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
          {props.title}
        </Typography>
        <Typography level="body-sm">يحتوي العنوان الخاص بك على عدد حروف وهو {numberOfCharacters}</Typography>
      </CardContent>
      { statustitle === "true" ? (
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} />
) : statustitle === "correct" ? (
  <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} />
) : statustitle === "false" ? (
  <ClearIcon style={{ color: "red",fontSize: "50px" }} />
) : null }


      
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
             من الناحية المثالية يجب ان يكون عنوانك يحتوي ما بين 10 ال 40 حرف بما في ذلك المسافات ويجب ايضا ان يحتوي على كلمات مفتاحية خاصة بالموقع
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    <DialogDescription description={description} />
    </div>

  )
}
